import { AppUtil } from 'kuaidong-lib'
import { School } from 'kuaidong-model'

export function getUserInfo(target: string): Promise<any> {
  return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/wx_pub/get_user_info`, {
    target: target,
  })
}

export function addWxBind(phone: string, smsCode: string): Promise<any> {
  return AppUtil.httpPOST(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/wx_pub/bind`, {
    phone,
    verify_code: smsCode,
  })
}

export function delWxBind(): Promise<any> {
  return AppUtil.httpDelete(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/wx_pub/bind`, {})
}

export async function searchSchools({
  province,
  city,
  district,
}: {
  province: string
  city: string
  district: string
}): Promise<{
  junior_schools: School[]
  primary_schools: School[]
}> {
  return AppUtil.httpGET(`${process.env.VUE_APP_CRAZYROPE_MANAGE_API}/schools/list`, { province, city, district })
}
